import React, { useState, useEffect } from 'react';
import axios from "../../../utils/fvAxios";
import { PDFDownloadLink, Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';

const SearchSIngleDownload = ({ ApiData }) => {
  const [apiData, setApiData] = useState([]);
  const [error, setError] = useState(null);
  const [pdfGenerated, setPdfGenerated] = useState(false);

  useEffect(() => {

    axios
      .post(
        "Employee/GetSpecificEmployeeQuizzes?VendorId=" + ApiData?.vendorid + "&EmployeeUserId=" + ApiData?.fvuserid
      )
      .then((res) => {
        if (res?.data) {
          setApiData(res?.data?.data);
          setPdfGenerated(true);
        } else {
          setError(res?.data?.responseMessage);
        }
      })
      .catch((err) => {
        console.log(err);
        setError("Error fetching API data");
      });
  }, []);

  const styles = StyleSheet.create({
    page: {
      flexDirection: 'row',
      backgroundColor: '#F5F5F5', // Light Gray background color
      padding: 20,
    },
    section: {
      flexGrow: 1,
    },
    header: {
      fontSize: 16,
      fontWeight: 'bold',
      marginBottom: 10,
      textAlign: 'center',
      color: '#2980B9', // Curious Blue color
    },
    itemHeader: {
      fontSize: 12,
      fontWeight: 'bold',
      marginBottom: 5,
      backgroundColor: '#E74C3C', // Alizarin background color
      padding: 5,
      color: '#FFFFFF', // White color
    },
    tableContainer: {
      marginTop: 10,
      backgroundColor: '#FCFCFC', // Pearl White background color
      padding: 10,
      borderWidth: 1,
      borderColor: '#BDC3C7', // Silver Sand color
    },
    tableHeaderText: {
      fontWeight: 'bold',
      fontSize: 12,
      paddingVertical: 6,
      paddingHorizontal: 10,
      backgroundColor: '#27AE60', // Nephritis background color
      color: '#FFFFFF', // White color
    },
    tableDataText: {
      fontSize: 12,
      paddingVertical: 6,
      paddingHorizontal: 10,
      color: '#FFFFFF', // Wet Asphalt color
    },
    tableRow: {
      flexDirection: 'row',
      borderBottomWidth: 1,
      borderBottomColor: '#95A5A6', // Concrete color
      paddingBottom: 5,
      marginBottom: 5,
    },
    tableRowOdd: {
      backgroundColor: '#F2D7EE', // Lavender Rose background color
    },
    tableHeader: {
      flex: 1,
      textAlign: 'center',
      color: '#FFFFFF', // Wisteria color
    },
    tableData: {
      flex: 1,
      textAlign: 'center',
      color: '#3498DB', // Dodger Blue color
    },
    smallTableContainer: {
      marginTop: 10,
      backgroundColor: '#FDEDEC', // Almond Frost background color
      padding: 10,
      borderWidth: 1,
      borderColor: '#D1C4E9', // Lavender color
    },
    smallTableRow: {
      flexDirection: 'row',
      borderBottomWidth: 1,
      borderBottomColor: '#8E44AD', // Wisteria color
      paddingBottom: 5,
      marginBottom: 5,
    },
    smallTableRowOdd: {
      backgroundColor: '#F9EBEA', // Melon background color
    },
    smallTableHeader: {
      flex: 1,
      fontSize: 10,
      paddingVertical: 4,
      paddingHorizontal: 6,
      backgroundColor: '#27AE60', // Nephritis background color
      color: '#FFFFFF', // White color
    },
    smallTableDataText: {
      fontSize: 10,
      paddingVertical: 4,
      paddingHorizontal: 6,
      color: '#34495E', // Wet Asphalt color
    },
    smallTableData: {
      flex: 1,
      color: '#E74C3C', // Alizarin color
    },
  });

  const generatePdf = () => (

    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles?.section}>
          <Text style={styles?.header}>Employee Summary</Text>
          <View style={styles?.tableContainer}>
            <View style={[styles?.tableRow, styles?.tableHeaderText]}>
              <Text style={[styles?.tableHeaderText, styles?.tableHeader]}>Vendor</Text>
              <Text style={[styles?.tableHeaderText, styles?.tableHeader]}>Employee Name</Text>
              <Text style={[styles?.tableHeaderText, styles?.tableHeader]}>Email</Text>
              <Text style={[styles?.tableHeaderText, styles?.tableHeader]}>Title</Text>
              <Text style={[styles?.tableHeaderText, styles?.tableHeader]}>ID Type</Text>
              <Text style={[styles?.tableHeaderText, styles?.tableHeader]}>Last 4 Digits of ID</Text>
            </View>
            <View style={[styles?.tableRow]}>
              <Text style={[styles?.tableDataText, styles?.tableData]}>{ApiData?.vendorname}</Text>
              <Text style={[styles?.tableDataText, styles?.tableData]}>{ApiData?.firstname},{ApiData?.lastname}</Text>
              <Text style={[styles?.tableDataText, styles?.tableData]}>{ApiData?.fvusername}</Text>
              <Text style={[styles?.tableDataText, styles?.tableData]}>{ApiData?.title ? ApiData?.title : "-"}</Text>
              <Text style={[styles?.tableDataText, styles?.tableData]}>{ApiData?.documenttype ? ApiData?.documenttype : "-"}</Text>
              <Text style={[styles?.tableDataText, styles?.tableData]}>{ApiData?.last4digitsofid}</Text>
            </View>
          </View>
          {apiData?.map((item, i) => (
            <View key={i} style={{ padding: "20px" }}>
              <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                <Text style={styles?.itemHeader}>Client Name: {item[0]?.clientname}</Text>
                <Text style={[styles?.itemHeader, { float: 'right' }]}>Status: {Array.from(new Set(item.map((r) => r?.quizstatus))).join(", ")}</Text>
              </View>
              <View style={styles?.smallTableContainer}>
                <View style={styles?.smallTableRow}>
                  <Text style={[styles?.smallTableHeaderText, styles?.smallTableHeader]}>Course</Text>
                  <Text style={[styles?.smallTableHeaderText, styles?.smallTableHeader]}>Status</Text>
                  <Text style={[styles?.smallTableHeaderText, styles?.smallTableHeader]}>Last Watched</Text>
                  <Text style={[styles?.smallTableHeaderText, styles?.smallTableHeader]}>Expires</Text>
                  <Text style={[styles?.smallTableHeaderText, styles?.smallTableHeader]}>Prev Passed</Text>
                  <Text style={[styles?.smallTableHeaderText, styles?.smallTableHeader]}>Renewal</Text>
                </View>
                {item?.map((r, index) => (
                  <View key={index} style={[styles?.smallTableRow, index % 2 === 0 && styles?.smallTableRowOdd]}>
                    <Text style={[styles?.smallTableDataText, styles?.smallTableData]}>{r?.coursename}</Text>
                    <Text style={[styles?.smallTableDataText, styles?.smallTableData]}>{r?.quizstatus}</Text>
                    <Text style={[styles?.smallTableDataText, styles?.smallTableData]}>{r?.lastwatched}</Text>
                    <Text style={[styles?.smallTableDataText, styles?.smallTableData]}>{r?.expiringdate ? r?.expiringdate : "-"}</Text>
                    <Text style={[styles?.smallTableDataText, styles?.smallTableData]}>{r?.previouslypassed ? r?.previouslypassed : "-"}</Text>
                    <Text style={[styles?.smallTableDataText, styles?.smallTableData]}>{r?.isrenewal ? "Yes" : "No"}</Text>
                  </View>
                ))}
              </View>
            </View>
          ))}

        </View>
      </Page>
    </Document>
  );

  return (
    <div>
      {/* {apiData?.length > 0 && ( */}
      <PDFDownloadLink document={generatePdf()} fileName="EmployeeSummary.pdf">
        {({ blob, url, loading, error }) =>
          loading ? 'Loading' : 'Download'
        }
      </PDFDownloadLink>
      {/* )} */}
      {error && <p>Error: {error}</p>}
    </div>
  );
};

export default SearchSIngleDownload;
